import { 
  CheckCircle, 
  Clock, 
  ShieldCheck, 
  Users, 
  Target,
  Handshake,
  Lightning
} from "@phosphor-icons/react";

const reasons = [
  {
    icon: Users,
    title: "Experiencia real",
    description: "En operación comercial e industrial"
  },
  {
    icon: ShieldCheck,
    title: "Personal calificado",
    description: "Equipo técnico y operativo certificado"
  },
  {
    icon: Clock,
    title: "Cumplimiento",
    description: "De cronogramas exigentes"
  },
  {
    icon: Lightning,
    title: "Respuesta rápida",
    description: "Ante urgencias y emergencias"
  },
  {
    icon: Target,
    title: "Seguridad industrial",
    description: "Como prioridad en cada proyecto"
  },
  {
    icon: CheckCircle,
    title: "Soluciones integrales",
    description: "En un solo proveedor"
  },
  {
    icon: Handshake,
    title: "Trato profesional",
    description: "Serio y confiable"
  }
];

const focusAreas = [
  "Continuidad operativa",
  "Cumplimiento normativo",
  "Seguridad industrial",
  "Optimización presupuestal",
  "Ejecución bajo cronogramas",
  "Alto sentido de servicio"
];

export function WhyUsSection() {
  return (
    <section
      data-testid="why-us-section"
      className="section-padding bg-[#0F172A] relative overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(45deg, #C92127 25%, transparent 25%), linear-gradient(-45deg, #C92127 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #C92127 75%), linear-gradient(-45deg, transparent 75%, #C92127 75%)`,
            backgroundSize: '60px 60px',
            backgroundPosition: '0 0, 0 30px, 30px -30px, -30px 0px'
          }}
        />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left - Why Choose Us */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-0.5 bg-[#C92127]" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
                ¿Por qué elegirnos?
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-12">
              Razones para <span className="text-[#C92127]">confiar</span> en nosotros
            </h2>

            <div className="grid sm:grid-cols-2 gap-6">
              {reasons.map((reason, index) => {
                const Icon = reason.icon;
                return (
                  <div
                    key={index}
                    className="flex items-start gap-4 p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
                  >
                    <div className="w-10 h-10 rounded-lg bg-[#C92127]/20 flex items-center justify-center flex-shrink-0">
                      <Icon size={20} weight="duotone" className="text-[#C92127]" />
                    </div>
                    <div>
                      <h4 className="font-bold text-white mb-1">{reason.title}</h4>
                      <p className="text-sm text-slate-400">{reason.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right - Focus Areas */}
          <div>
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 lg:p-12 border border-white/10">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-8">
                Enfoque <span className="text-[#C92127]">SEINMAR</span>
              </h3>
              <p className="text-slate-300 mb-8 leading-relaxed">
                Trabajamos exclusivamente en el sector comercial e industrial, 
                orientados a generar resultados medibles y proteger la operación 
                de nuestros clientes.
              </p>

              <div className="space-y-4">
                {focusAreas.map((area, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 rounded-lg bg-[#C92127]/10 border border-[#C92127]/20"
                  >
                    <CheckCircle size={24} weight="fill" className="text-[#C92127]" />
                    <span className="text-white font-medium">{area}</span>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="mt-10 pt-8 border-t border-white/10">
                <p className="text-slate-300 mb-4">
                  Más que ejecutar servicios, nos convertimos en{" "}
                  <span className="text-[#C92127] font-semibold">aliados estratégicos</span>{" "}
                  para la operación de nuestros clientes.
                </p>
                <a
                  href="#contacto"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="btn-primary inline-block"
                  data-testid="why-us-cta"
                >
                  Ser su Aliado
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUsSection;
